import React from "react";
import Header from "./Header";
import Router from "./Router";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div>
      <Header />
      <Router />
      <Footer />
    </div>
  );
};

export default Layout;
